import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  // Skip adding auth headers for login endpoint
  if (req.url.includes('/auth/login')) {
    return next(req);
  }

  // Skip if Authorization header is already set (allows services to override if needed)
  if (req.headers.has('Authorization')) {
    return next(req);
  }

  // Get JWT token from localStorage
  const token = localStorage.getItem('auth_token');
  const credentials = localStorage.getItem('auth_credentials');

  // Clone the request and add the authorization header
  if (token) {
    const clonedRequest = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
    console.log('[AuthInterceptor] Adding Bearer token to request:', req.url);
    return next(clonedRequest);
  } else if (credentials) {
    // Fallback to Basic auth if no JWT token
    const clonedRequest = req.clone({
      setHeaders: {
        Authorization: `Basic ${credentials}`
      }
    });
    console.log('[AuthInterceptor] Adding Basic auth to request:', req.url);
    return next(clonedRequest);
  }

  // No auth available, proceed without auth header
  console.warn('[AuthInterceptor] No auth token or credentials found for request:', req.url);
  return next(req);
};
